<script setup lang="ts">
// TODO: modules/ should not import anyting from outside or core/. Deal with this.
import { formatDistance } from '@libs/utils';

import type { Distance } from '../../models';

interface ActivityDescriptionDistancesProps {
  distances: Distance[];
}

const props = defineProps<ActivityDescriptionDistancesProps>();
</script>

<template>
  <div class="activity-description-distances">
    <div class="title">
      {{ $t('planner.distances') }}
    </div>
    <div
      v-for="distance in props.distances"
      :key="distance.description"
      class="distance"
    >
      <div>{{ distance.description }}</div>
      <div>{{ formatDistance(distance.distanceMeters) }}</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.activity-description-distances {
  margin-bottom: var(--spacing-32);

  .title {
    color: var(--color-soft-black);
    @include font-heading-5;
    margin-bottom: var(--spacing-16);
  }

  .distance {
    display: flex;
    justify-content: space-between;
    @include font-label-l-light;
    padding-bottom: var(--spacing-16);
  }
}
</style>
